<template>
  <BaseDropdown
    inverted
    required
    :options="mappedPaymentMethods"
    :label="t('reports.totals.payment_method')"
    v-model="selectedPaymentMethod"
    v-test="'refund-payment-method'"
  />
</template>

<script
  setup
  lang="ts"
>
import { useQuery } from '@vue/apollo-composable';
import { inject, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { brandNamePay } from '@/helpers/brand-name';
import { GET_PAYMENT_METHODS } from '../graphql';

const { t } = useI18n();

const selectedPaymentMethod = inject<Ref<string>>('selectedPaymentMethod');

const { result: paymentMethodsResult } = useQuery(GET_PAYMENT_METHODS, {
  register: true,
});

const paymentMethods = computed(
  () => paymentMethodsResult.value?.paymentMethods || [],
);

const allowedPaymentMethods = [
  'BANK',
  'CASH',
  'COUPON',
  'CREDITCARD',
  'PIN',
  'CHEQUE',
];

const filteredPaymentMethods = computed(() => {
  return paymentMethods.value.filter((method: string) =>
    allowedPaymentMethods.includes(method),
  );
});

const mappedPaymentMethods = computed(() => {
  return filteredPaymentMethods.value.map((method: string) => ({
    label: t(`global.payments.${method.toLowerCase()}`, brandNamePay()),
    value: method,
  }));
});
</script>
